// Toast bus, ported from agent-sandbox/ui/src/toast.tsx without its config-save
// helper (that belonged to the sandbox's API). The component that renders toasts is
// in Toaster.tsx; this file holds the imperative side so `toast()` can be called from
// anywhere, including outside React.

export type Tone = "ok" | "warn";

export interface ToastItem {
  id: number;
  msg: string;
  tone: Tone;
}

let counter = 0;
const listeners = new Set<(t: ToastItem) => void>();

/** Show a transient toast. */
export function toast(msg: string, tone: Tone = "ok"): void {
  const t = { id: ++counter, msg, tone };
  listeners.forEach((l) => l(t));
}

/** Receive every toast until the returned function is called. */
export function subscribe(listener: (t: ToastItem) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
